var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletterBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 300,
    viewBox: "0 0 675 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 674.564,
    height: 300,
    fill: "#121332"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1027_83389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 675,
    height: 300
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 675,
    height: 300,
    fill: "#121332"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1027_83389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.84 343.499C161.873 325.697 184.287 291.044 148.177 248.551C103.421 195.884 -33.7791 194.401 -24.2413 128.382C-13.8083 56.1664 165.052 152.861 211.275 78.6827C248.253 19.3399 255.052 -64.729 242.09 -71.1578C286.846 -101.324 382.52 -143.556 407.172 -71.1578C437.987 19.3398 562.715 29.725 562.715 78.6827C562.715 127.64 492.281 120.223 498.15 201.077C501.594 248.518 612.851 305.944 672.77 327.18M710.188 -19.2329C678.395 -45.9372 609.085 -85.2517 586.193 -28.8761C557.579 41.5934 615.541 75.7154 619.21 127.64C622.878 179.565 520.161 264.871 498.15 319.763C480.541 363.676 501.819 399.381 515.759 416.936",
    stroke: "#C824C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2586 -42.228C89.4814 -18.9855 155.514 45.1541 102.688 100.936C36.6551 170.664 -17.9541 218.275 23.4491 297.509C43.9927 336.824 78.2312 349.187 87.2802 348.692",
    stroke: "#C824C1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1027_83389)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.000320435,
    cy: -0.000038147,
    rx: 96.8478,
    ry: 97.9155,
    fill: "#C824C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1027_83389)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.172,
    cy: 316.054,
    rx: 96.8478,
    ry: 97.9155,
    fill: "#C824C1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1027_83389",
    x: -180.848,
    y: -181.916,
    width: 361.696,
    height: 363.831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_1027_83389"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1027_83389",
    x: 496.324,
    y: 134.138,
    width: 361.696,
    height: 363.831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42,
    result: "effect1_foregroundBlur_1027_83389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterBackground);
export default __webpack_public_path__ + "static/media/NewsletterBackground.ed467c7867f3d0556b2af20fb02d2e12.svg";
export { ForwardRef as ReactComponent };